"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseHeaders = exports.hasData = exports.hasParams = void 0;

var _tslib = require("tslib");

var _useGlobalState = require("../useGlobalState");

var _utility = require("../account/utility");

var DEFAULT_LOCALE = 'en-US';

var hasParams = function hasParams(method) {
  return method === 'get' || method === 'options' || method === 'head' || method === 'request' || method === 'delete';
};

exports.hasParams = hasParams;

var hasData = function hasData(method) {
  return method === 'post' || method === 'put' || method === 'patch';
};

exports.hasData = hasData;

var getAuthorization = function getAuthorization() {
  var token = (0, _utility.getToken)();
  return token ? {
    Authorization: "Bearer " + token
  } : {};
};

var baseHeaders = function baseHeaders(isAsync) {
  if (isAsync === void 0) {
    isAsync = false;
  }

  var locale = (0, _useGlobalState.useGlobalState)('locale', isAsync)[0];
  return (0, _tslib.__assign)((0, _tslib.__assign)({}, getAuthorization()), {
    'Accept-Language': locale || DEFAULT_LOCALE,
    // we need to switch from no cache to cache with max-age
    'Cache-Control': 'no-cache, max-age=0'
  });
};

exports.baseHeaders = baseHeaders;